import { ReactNode } from "react";

// El ícono es opcional a propósito: las páginas que ya lo tenían así antes
// de este cambio (Suscripción, Configuración, Reportes) siguen viéndose
// igual si nadie les pasa un ícono — nada se rompe por no actualizarlas.
// Cuando sí se pasa un ícono, se dibuja un cintillo con un degradado suave
// del color de marca del negocio (bg-brand-*, que ya reacciona al
// colorPrimario de cada negocio vía frontend/src/lib/tema.ts) detrás de un
// círculo con el ícono — pensado para que cada sección del panel se sienta
// más viva y "temática", sin depender de una sola paleta fija para todos.
export function PageHeader({
  titulo,
  descripcion,
  acciones,
  icono,
}: {
  titulo: string;
  descripcion?: string;
  acciones?: ReactNode;
  icono?: ReactNode;
}) {
  if (!icono) {
    return (
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-xl font-semibold text-slate-800">{titulo}</h1>
          {descripcion && <p className="mt-1 text-sm text-slate-500">{descripcion}</p>}
        </div>
        {acciones && <div className="flex items-center gap-2">{acciones}</div>}
      </div>
    );
  }

  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-4 rounded-3xl bg-gradient-to-r from-brand-50 via-brand-50/60 to-transparent p-5">
      <div className="flex items-center gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-brand-600 text-white shadow-sm">
          {icono}
        </div>
        <div>
          <h1 className="text-xl font-semibold text-slate-800">{titulo}</h1>
          {descripcion && <p className="mt-1 text-sm text-slate-500">{descripcion}</p>}
        </div>
      </div>
      {acciones && <div className="flex items-center gap-2">{acciones}</div>}
    </div>
  );
}
